module.exports = __webpack_public_path__ + "media/images/brands/mundo_ripilica_page-45cc9cb50780216d3cb80dd7358671d9.png";